// Helpers de formatação consistente.

export function formatTokens(n?: number): string {
  if (n == null) return '—';
  if (n < 1000) return `${n}`;
  if (n < 1_000_000) return `${(n / 1000).toFixed(1).replace('.0', '')}k`;
  return `${(n / 1_000_000).toFixed(2).replace('.00', '')}M`;
}

export function formatDuration(s?: number): string {
  if (s == null) return '—';
  if (s < 1) return `${(s * 1000).toFixed(0)}ms`;
  if (s < 60) return `${s.toFixed(2)}s`;
  const m = Math.floor(s / 60);
  return `${m}m ${(s - m * 60).toFixed(0)}s`;
}

export function formatCost(usd?: number): string {
  if (usd == null) return '—';
  if (usd < 0.001) return `$${(usd * 1000).toFixed(2)}m`;
  return `$${usd.toFixed(4)}`;
}

export function formatDate(unix?: number): string {
  if (!unix) return '—';
  return new Date(unix * 1000).toLocaleString('pt-BR', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function formatRelative(when?: number | string | null): string {
  if (when == null || when === '') return '—';
  // Aceita epoch segundos (número) ou ISO string. Normaliza pra epoch segundos.
  const unix =
    typeof when === 'number' ? when : Math.floor(new Date(when).getTime() / 1000);
  if (!Number.isFinite(unix) || unix === 0) return '—';
  const diffSec = Math.floor(Date.now() / 1000 - unix);
  const abs = Math.abs(diffSec);
  const suffix = diffSec < 0 ? 'em' : '';
  const ago = diffSec < 0 ? '' : 'atrás';
  const fmt = (n: number, unit: string) => (suffix ? `${suffix} ${n}${unit}` : `${n}${unit} ${ago}`).trim();
  if (abs < 60) return fmt(abs, 's');
  if (abs < 3600) return fmt(Math.floor(abs / 60), ' min');
  if (abs < 86400) return fmt(Math.floor(abs / 3600), ' h');
  return fmt(Math.floor(abs / 86400), ' dias');
}

export function truncate(s: string, n = 80): string {
  return s.length <= n ? s : s.slice(0, n - 1) + '…';
}

/**
 * Encurta um host (sem protocolo) para exibição: tira o sufixo `.ai.blips.com.br`
 * e, se for de outro domínio, fica só com o primeiro label DNS. IPs e hosts sem
 * ponto (ex.: `localhost:8000`) ficam como estão.
 */
export function shortHost(host: string): string {
  const suffix = '.ai.blips.com.br';
  if (host.endsWith(suffix)) return host.slice(0, -suffix.length);
  if (/^\d{1,3}(\.\d{1,3}){3}(:\d+)?$/.test(host)) return host;
  return host.split('.')[0] || host;
}
